import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TCreateCompanyAccountRequestSchema,
  TCreateCompanyAccountResponseSchema,
} from "./createCompanyAccount.schema";

export const createCompanyAccount = (axios: IAxiosInstance) => {
  return async ({
    odoUserId,
    account_type,
    perform_kyc = false,
  }: TCreateCompanyAccountRequestSchema) => {
    const response = await axios.noRetry.post<
      IApiResponse<TCreateCompanyAccountResponseSchema>
    >(`/api/companies/${odoUserId}/${account_type}?perform_kyc=${perform_kyc}`);

    return response.data;
  };
};
